/* eslint-env browser */
import React, { useCallback } from 'react';
import ShareIcon from './ShareIcon';
import BsFacebook from '../icons/BsFacebook';
import BsEnvelope from '../icons/BsEnvelope';
import BsPrinter from '../icons/BsPrinter';
import { useLocation } from 'react-router-dom';
import '../styles/ShareIconList.css';


/** CONFIGURATION */
const BASE_URL = process.env.APP_URL.replace(/\/$/, '');

const ShareIconList = () => {
    const location = useLocation();
    const url = `${BASE_URL}${location.pathname}`;

    const handlePrint = useCallback((e) => {
        e.preventDefault();
        window.print();
    }, []);

    return <div
        className={'share-icon-list'}>
        <ShareIcon
            link={`https://www.facebook.com/sharer.php?u=${url}`}
        ><BsFacebook /></ShareIcon>
        <ShareIcon
            link={`mailto:?subject=Check this out&body=${url}`}
        ><BsEnvelope /></ShareIcon>
        <ShareIcon
            link={'#'}
            onClick={handlePrint}
        ><BsPrinter /></ShareIcon>
    </div>;
};

export default ShareIconList;